































































































































































    import { Component, Vue, Inject} from 'vue-property-decorator';
    import iView from 'iview';
    import Ajax from '../../../lib/ajax'
    import AbpBase from '../../../lib/abpbase'
    import contractAddTypeModal from './contractAddTypeModal.vue'
    import advancedSearch from '../../../components/tools/advancedSearch.vue'   
    import Appconst from '../../../lib/appconst'; 
    import { constants } from 'http2';
import ajax from '../../../lib/ajax';
    @Component({
        name:'contractList',
        components: {
            contractAddTypeModal,
            advancedSearch
        },
    })
    export default class contractList extends AbpBase  {
        $store:any
        $Message:any
        $Modal:any
        $router:any
        initData:any = {
            column:{   //自定义显示列
                visible:false,
                dropdownCheckAllGroup:[],
                indeterminate:false,
                checkAll:true, //是否全选 true:全 false:不
                dropdownCheckAllList:[],//自定义列的列表
            },
            label:{
                model:false,
                labelValue:null,
                contractIds:[],//标注选中的合同id
            },
            searchData: {
                SignDate: undefined,
                BelongOrgId: undefined,
                ContractType: undefined,
                Keyword: undefined
            },
            tableData: {
                title: [
                    {
                        type: 'selection',
                        width: 60,
                        align: 'center',
                        fixed: 'left'
                    },
                    {
                        title: '合同编号',
                        key: 'contractCode',
                        width: 150,
                        align: 'center',
                        sortable: 'custom',
                        fixed: 'left'
                    },
                    {
                        title: '合同名称',
                        key: 'contractName',
                        width: 350,
                        align: 'center',
                        fixed: 'left',
                        render:(h:any, params:any) => {
                                return h('a', {
                                    on:{
                                        click:() => {
                                            this.ToDetail(params.row);
                                        }
                                    }
                                },params.row.contractName)
                        }
                    },
                    {
                        title: '合同类别',
                        key: 'projectCatalog',
                        width: 200,
                        align: 'center',
                        render: (h:any, params:any)=>{
                            return h('Row', [
                                h('Col', {}, params.row.projectCatalog ? params.row.projectCatalog.catalogName : '')
                            ])
                        }
                    },
                    {
                        title: '签订单位',
                        key: 'signUnit',
                        width: 300,
                        align: 'center',
                        render: (h:any, params:any)=>{
                            return h('Row', [
                                h('Col', {}, params.row.signUnit ? params.row.signUnit.unitName : '')
                            ])
                        }
                    },
                    {
                        title: '所属部门',
                        key: 'belongOrg',
                        width: 150,
                        align: 'center',
                        render: (h:any, params:any)=>{
                            return h('Row', [
                                h('Col', {}, params.row.belongOrg ? params.row.belongOrg.displayName : '')
                            ])
                        }
                    },
                    {
                        title: '二级部门',
                        key: 'secondBelongOrg',
                        width: 150,
                        align: 'center',
                        render: (h:any, params:any)=>{
                            return h('Row', [
                                h('Col', {}, params.row.secondBelongOrg ? params.row.secondBelongOrg.displayName : '')
                            ])
                        }
                    },
                    {
                        title: '业主单位',
                        key: 'ownerUnit',
                        width: 250,
                        align: 'center'
                    },
                    {
                        title: '资金来源',
                        key: 'fundsSourceDesc',
                        width: 300,
                        align: 'center'
                    },
                    {
                        title: '合同金额(万元)',
                        key: 'contractAmountFormat',
                        width: 150,
                        align: 'center',
                        sortable: 'custom'
                    },
                    {
                        title: '合同签订日期',
                        key: 'signDt',
                        width: 150,
                        align: 'center',
                        sortable: 'custom',
                        render: (h:any, params:any)=>{
                            return h('Row', [
                                h('Col', {}, params.row.signDt ? params.row.signDt.substring(0, 10) : '')
                            ])
                        }
                    },
                    {
                        title: '合同起止日期',
                        key: 'time',
                        width: 200,
                        align: 'center',
                        render: (h:any, params:any)=>{
                            return h('Row', [
                                h('Col', {}, (params.row.beginDt && params.row.endDt) ? params.row.beginDt.substring(0, 10)+'至'+params.row.endDt.substring(0, 10) : '')
                            ])
                        }
                    },
                    {
                        title: '合同备案日期',
                        key: 'keepOnRecordDt',
                        width: 150,
                        align: 'center',
                        sortable: 'custom',
                        render: (h:any, params:any)=>{
                            return h('Row', [
                                h('Col', {}, params.row.keepOnRecordDt ? params.row.keepOnRecordDt.substring(0, 10) : '')
                            ])
                        }
                    },
                    {
                        title: '合同签订人',
                        key: 'signUser',
                        width: 150,
                        align: 'center',
                        render: (h:any, params:any)=>{
                            return h('Row', [
                                h('Col', {}, params.row.contractSignUser ? params.row.contractSignUser.name : '')
                            ])
                        }
                    },
                    {
                        title: '项目负责人',
                        key: 'projectLeader',
                        width: 150,
                        align: 'center',
                        render: (h:any, params:any)=>{
                            return h('Row', [
                                h('Col', {}, params.row.contractProjectLeader ? params.row.contractProjectLeader.name : '')
                            ])
                        }
                    },
                    {
                        title: '盖章份数',
                        key: 'sealCount',
                        width: 150,
                        align: 'center'
                    },
                    {
                        title: '经办人',
                        key: 'agentUser',
                        width: 150,
                        align: 'center',
                        render: (h:any, params:any)=>{
                            return h('Row', [
                                h('Col', {}, params.row.agentUser ? params.row.agentUser.name : '')
                            ])
                        }
                    },
                    {
                        title: '报告盖章份数',
                        key: 'reportStampCount',
                        width: 150,
                        align: 'center'
                    },
                    {
                        title: '报告是否盖章',
                        key: 'isReportStamped',
                        width: 150,
                        align: 'center',
                        render:(h:any,params:any)=>{
                            if(params.row.isChangeReportStampEnable){
                                return h('Dropdown',  [
                                    h('div', {
                                    class: {
                                        member_operate_div: true
                                    }
                                    }, [
                                        h('a', {
                                            props: {
                                                type: 'primary',
                                                size: 'small'
                                            }
                                        }, [
                                            h('span', params.row.isReportStamped ? params.row.reportStampCount?'是（' + params.row.reportStampCount +'份)':'是' : '否'),
                                            h('Icon', { })
                                        ])
                                    ]),
                                    h('DropdownMenu', {
                                        slot: 'list'
                                    }, [
                                    h('DropdownItem', {
                                        props: {
                                            name: 'edit'
                                        }
                                    }, [
                                        h('Button', {
                                            props: {
                                                type: 'text',
                                                size: 'small'
                                            },
                                            style:{
                                                margin:'auto'
                                            },
                                            on: {
                                                click: () => {
                                                    this.changReport(params.row,'yes');
                                                }
                                            }
                                            }, '是'),
                                        h('Button', {
                                            props: {
                                                type: 'text',
                                                size: 'small',
                                            },
                                            style:{
                                                margin:'auto'
                                            },
                                            on: {
                                                click: () => {
                                                    this.changReport(params.row,'no');
                                                }
                                            }
                                            }, '否')
                                        ])
                                    ])
                                ])  
                            } else {
                                return h('div',params.row.isReportStamped ? '是（' + params.row.reportStampCount +'份)' : '否')
                            }
                            
                        }
                    },
                    {
                        title: '完工时间',
                        key: 'completeDt',
                        width: 150,
                        align: 'center',
                        sortable: 'custom',
                        render: (h:any, params:any)=>{
                            return h('Row', [
                                h('Col', {}, params.row.completeDt ? params.row.completeDt.substring(0, 10) : '')
                            ])
                        }
                    },
                    {
                        title: '归档时间',
                        key: 'archieveDt',
                        width: 150,
                        align: 'center',
                        sortable: 'custom',
                        render: (h:any, params:any)=>{
                            return h('Row', [
                                h('Col', {}, params.row.archieveDt ? params.row.archieveDt.substring(0, 10) : '')
                            ])
                        }
                    },
                    {
                        title: '预收款(万元)',
                        key: 'prePaymentFormat',
                        width: 150,
                        align: 'center',
                        sortable: 'custom'
                    },
                    {
                        title: '收款总额(万元)',
                        key: 'totalReceiptsFormat',
                        width: 150,
                        align: 'center',
                        sortable: 'custom'
                    },
                    {
                        title: '未收款(万元)',
                        key: 'unreceivableFormat',
                        width: 150,
                        align: 'center',
                        sortable: 'custom'
                    },
                    {
                        title: '标注',
                        key: 'contractLabelDesc',
                        width: 150,
                        align: 'center',
                        className:'bz-cell',
                        render:(h:any,params:any)=>{
                            if (params.row.isChangeLabelEnable) {
                                return h('Dropdown',  [
                                    h('div', {
                                    class: {
                                        member_operate_div: true
                                    }
                                    }, [
                                        h('a', {
                                            props: {
                                                type: 'primary',
                                                size: 'small'
                                            }
                                        }, [
                                            h('span', params.row.contractLabelDesc?params.row.contractLabelDesc:'无'),
                                            h('Icon', { })
                                        ])
                                    ]),
                                    h('DropdownMenu', {
                                        slot: 'list'
                                    }, [
                                    h('DropdownItem', {
                                        props: {
                                            name: 'edit'
                                        }
                                    }, [
                                        h('Button', {
                                            props: {
                                                type: 'text',
                                                size: 'small'
                                            },
                                            on: {
                                                click: () => {
                                                    this.initData.label.contractIds.push(params.row.id);
                                                    this.initData.label.labelValue = 1;
                                                    this.saveLabel();
                                                }
                                            }
                                            }, '正式合同'),
                                        h('Button', {
                                            props: {
                                                type: 'text',
                                                size: 'small',
                                            },
                                            on: {
                                                click: () => {
                                                    this.initData.label.contractIds.push(params.row.id);
                                                    this.initData.label.labelValue = 2;
                                                    this.saveLabel()
                                                }
                                            }
                                            }, '非正式合同')
                                        ])
                                    ])
                                ])
                            } else {
                                return h('div',params.row.contractLabelDesc?params.row.contractLabelDesc:'无')
                            }
                            
                        }
                    },
                    {
                        title: '备注',
                        key: 'remark',
                        width: 200,
                        ellipsis: true,
                        align: 'center',
                        render:(h:any,params:any) => {
                            return h('div',{
                                class:{
                                    'remark-div':true
                                }
                            },[
                                h('p',params.row.remark,),
                                h('Button',{
                                    props: {
                                        size: 'small',
                                    },
                                    class:{
                                        'remark-btn':params.row.isChangeRemarkEnable?true:false
                                    },
                                    style: {
                                        margin: 'auto'
                                    },
                                    on: {
                                        click: () => {
                                            this.changeRemark(params);  
                                        }
                                    }
                                },'编辑')]) 
                        }
                    }
                ],
                content: [],
                loading: true,
                newTitle:[],
                currentIndex:2,
            },
            dicData: {
                ContractType: null
            },
            addModal: {
                typeIsShow: false,
                mainIsShow: false,
                specialIsShow: false,
                btnLoading: true
            },
            showContractOutside: false,
            showAdvancedSearch: false,
            showContractLabel:false,//标注权限
            appBaseUrl: Appconst.appBaseUrl,  //地址
            tabsBool:true,
            stamp: false,
            stampNum: null,
            stampLoading: true,
            stampId: null,
            remarkModel: false,
            remarkLoading: true,
            remark:'',

            
        }
        dropdownHandleOpen () { //自定义显示列显示隐藏
            this.initData.column.visible = !this.initData.column.visible;
        }
        dropdownHandleCheckAll(){  //自定义列全选
            this.initData.column.dropdownCheckAllGroup = [];
            if (this.initData.column.indeterminate) {
                this.initData.column.checkAll = false;
            } else {
                this.initData.column.checkAll = !this.initData.column.checkAll;
            }
            this.initData.column.indeterminate = false;
            if (this.initData.column.checkAll) {
                this.initData.tableData.title.forEach((item:any,index:any) => {
                    if(index != 0){
                        this.initData.column.dropdownCheckAllGroup.push(item.key)
                    }
                });
                this.initData.column.dropdownCheckAllList.map( (item:any) => {
                    return item.isVisiblity = true;
                } )
            } else {
                this.initData.column.dropdownCheckAllGroup = [];
                this.initData.column.dropdownCheckAllList.map( (item:any) => {
                    return item.isVisiblity = false;
                } )
            }
        }
        dropdownCheckAllGroupChange(res:any){  //自定义列单选
            if (res.length === this.initData.column.dropdownCheckAllList.length) {
                this.initData.column.indeterminate = false;
                this.initData.column.checkAll = true;
            } else if (res.length > 0) {
                this.initData.column.indeterminate = true;
                this.initData.column.checkAll = false;
            } else {
                this.initData.column.indeterminate = false;
                this.initData.column.checkAll = false;
            }
            //获取得到的值
            this.initData.column.dropdownCheckAllList.map( (item:any) => {
                let bool:any = false;
                res.forEach( (val:any) => {
                    if(item.fieldEnName == val){
                        bool = true;
                    }
                } )
                if(!bool){
                    return item.isVisiblity = false;
                }else{
                    return item.isVisiblity = true;
                }
            } )
        }
        async saveDropdownColumn(){//保存列
            await Ajax.post('/api/services/app/UserHabits/SaveMainContractLedgerAsync',this.initData.column.dropdownCheckAllList);
            await this.$store.dispatch('session/GetCurrentLoginInformations');
            await this.setDropdownCheckAllList();
            this.changeColumn();
            this.initData.column.visible = false;
        }
        setDropdownCheckAllList(){//设置初始化的列
            this.initData.column.dropdownCheckAllGroup = [];
            if(this.initData.tableData.title.length-1 != this.$store.state.session.userHabits.ledger.mainContractLedger.length) {
                this.initData.tableData.title.forEach((item:any,index:any) => {
                    if(index != 0){
                        this.initData.column.dropdownCheckAllList.push({
                            fieldEnName:item.key,
                            fieldZhName:item.title,
                            isVisiblity:true,
                            isFixed:false,
                        })
                        this.initData.column.dropdownCheckAllGroup.push(item.key);
                    }
                });
                this.changeColumn();
                return;
            }
            if(this.$store.state.session.userHabits.ledger.mainContractLedger.length){
                this.initData.column.dropdownCheckAllList = this.$store.state.session.userHabits.ledger.mainContractLedger;
                this.$store.state.session.userHabits.ledger.mainContractLedger.forEach( (item:any) => {
                    if(item.isVisiblity){
                        this.initData.column.dropdownCheckAllGroup.push(item.fieldEnName);
                    }
                } )
                //设置全选按钮
                if (this.initData.column.dropdownCheckAllGroup.length === this.initData.column.dropdownCheckAllList.length) {
                    this.initData.column.indeterminate = false;
                    this.initData.column.checkAll = true;
                }else{
                    this.initData.column.indeterminate = true;
                    this.initData.column.checkAll = false;
                }
            }else{
                this.initData.tableData.title.forEach((item:any,index:any) => {
                    if(index != 0){
                        this.initData.column.dropdownCheckAllList.push({
                            fieldEnName:item.key,
                            fieldZhName:item.title,
                            isVisiblity:true,
                            isFixed:false,
                        })
                        this.initData.column.dropdownCheckAllGroup.push(item.key);
                    }
                });
            }
            this.changeColumn();
        }
        changeColumn(){ // 改变列
            let data:any = [this.initData.tableData.title[0]];
            this.initData.tableData.title.forEach( (item:any) => {
                this.initData.column.dropdownCheckAllGroup.forEach( (val:any) => {
                    if(item.key == val){
                        data.push(item);
                    }
                } )
            } )
            this.initData.tableData.newTitle = data;
        }
        // 改变备注
        changeRemark(data: any) {
            this.initData.remarkModel = true;
            this.initData.stampId = data.row.id;
        }
        subRemark(){
            if(!this.initData.remark) {
                this.$Message.error('请填写备注！');
                setTimeout(() => {
                    this.initData.remarkLoading= false;
                    this.$nextTick(() => {                            
                        this.initData.remarkLoading = true;
                    });
                }, 1000);
                return;  
            }
            Ajax.post('/api/services/app/Contract/ContractRemarkUpdateAsync',{
                contractId:this.initData.stampId,
                remark: this.initData.remark
            }).then( (res: any) => {
                this.$Message.success('修改成功!');
                this.GetData();
                this.initData.remarkModel = false;
                this.initData.remark = '';
            } )
        }
        // 是否盖章
        changReport(data: any, type: any){
            if (type == 'no') {
                this.$Modal.confirm({
                    title: '改变盖章状态',
                    content: '是否确定要修改吗？',
                    onOk: async () => {
                        Ajax.post('/api/services/app/Contract/ContractReportStampUpdateAsync',{
                            contractId: data.id,
                            isStamp: false
                        }).then( (res) => {
                            this.GetData();
                        } )
                    }
                });
            } else if (type == 'yes') {
                this.initData.stamp = true;
                this.initData.stampId = data.id;
            }
        }
        subStamp() {
            if(!this.initData.stampNum) {
                this.$Message.error('请填写盖章次数！');
                setTimeout(() => {
                    this.initData.stampLoading= false;
                    this.$nextTick(() => {                            
                        this.initData.stampLoading = true;
                    });
                }, 1000);
                return;  
            }
            Ajax.post('/api/services/app/Contract/ContractReportStampUpdateAsync',{
                contractId: this.initData.stampId,
                isStamp: true,
                stampCount: Number(this.initData.stampNum)
            }).then((res) => {
                this.$Message.success('修改成功!');
                this.GetData();
                this.initData.stamp = false;
                this.initData.stampNum = null;
            } )
        }
        //标注
        clickLabel(res:any){
            if(!this.initData.label.contractIds.length){
                this.$Message.error("请选择需要标记的合同！");
                return;
            }
            if(res == 'saveLabel'){
                this.initData.label.model = !this.initData.label.model;
            }else{
                this.$Modal.confirm({
                    title: '批量删除标注',
                    content: '是否批量删除勾选标注？',
                    onOk: async () => {
                        await Ajax.post('/api/services/app/Contract/ContractRemoveLabelAsync',{contractIds:this.initData.label.contractIds,labelValue:this.initData.label.labelValue,});
                        this.GetData();
                        this.initData.label.contractIds = [];
                    }
                });
            }
        }
        //单选
        singleChangeSel(selection:any){
           this.initData.label.contractIds = selection.map( (item:any) => {
                return item.id;
            } )
        }
        //保存标注
        async saveLabel(){
            await Ajax.post('/api/services/app/Contract/ContractAddLabelAsync',{contractIds:this.initData.label.contractIds,labelValue:this.initData.label.labelValue,});
            this.GetData();
            this.initData.label.contractIds = [];
        }
        //高级搜索
        ShowSearch() {
            (this as any).$refs.advancedSearch.Show(!this.initData.showAdvancedSearch);
            this.initData.showAdvancedSearch = !this.initData.showAdvancedSearch;
        }
        AdvancedSearch(data:any) {
            Object.assign(this.initData.searchData, data);
            console.log(this.initData.searchData,data)
            this.GetData();
        }
        ClearSearch() {
            this.initData.searchData = {};
        }
        //排序
        changeSort(data:any){
            this.initData.searchData.Sorting = data.key.replace(/( |^)[a-z]/g, (L:string) => L.toUpperCase()).replace('Format','');
            if(data.key == 'contractCode' ){
                this.initData.searchData.Sorting = "ContractSerialNumber";
            }
            if(data.order == 'asc'){
                this.initData.searchData.Ascending = true;
            }else if(data.order == 'desc') {
                this.initData.searchData.Ascending = false;
            }else{
                this.initData.searchData.Ascending = null;
                this.initData.searchData.Sorting = null;
            }
            this.GetData();
        }
        //获取列表数据
        async GetData() {
            this.initData.tableData.loading = true;
            this.initData.searchData.SignYear = this.initData.searchData.SignDate ? ~~this.initData.searchData.SignDate.getFullYear() : undefined;
            console.log(this.initData.searchData)
            let temp = (await Ajax.get('/api/services/app/Contract/GetAllMainByPagingAsync', {params: this.initData.searchData})).data.result;
            this.initData.tableData.content = temp.pageResult.items;
            this.initData.tableData.totalCount = temp.pageResult.totalCount;
            console.log(temp)
            //处理删选数据
            if(temp.statistic && temp.statistic.length){
                temp.statistic.map((item:any)=>{
                    if(item.catalog == 2){
                        this.initData.tableData.statistic = item.auditStatusItems;
                    }
                })
            }
            if(this.initData.tableData.content.length == 0){
                this.$Message.error('暂无数据！') 
            }
            this.initData.tableData.loading = false;
        }
        //合同切换
        SwitchContract(name:any) {
            this.$router.push({
                name: name
            })
        }
        //合同状态过滤
        FilterContract(type:any) {
            this.initData.tableData.currentIndex = type;
            this.initData.searchData.AuditStatus = type;
            this.GetData();
        }
        //合同详情
        ToDetail(e:any) {      
            (this as any).reloadComponent('contractDetail');
            this.$nextTick( () => {
                this.$router.push({
                    name: 'contractDetail',
                    query: {
                        id: e.id
                    }
                });
            } )
        }
        //合同登记选择类型弹窗-设置
        async GetContractType(type:any) {
            this.initData.addModal.typeIsShow = false; 
            (this as any).reloadComponent('contractAdd');
            this.$nextTick( ()=>{
                this.$router.push({
                    name: 'contractAdd',
                    query: {
                        contractMainType: type
                    }
                })
            } ) 
            // this.initData.addModal.contractMainType = type;
            // this.initData.addModal.mainIsShow = true;
        }
        //合同登记弹窗按钮-关闭回调
        AddModalClose(status:any){
            this.initData.addModal.btnLoading = status;
        }
        //合同登记弹窗-关闭
        CloseAddModal(status:any){
            this.initData.addModal.mainIsShow = false;
        }
        
        //分页获取数据
        ChangePage(page:any) {
            this.initData.searchData.SkipCount = page-1;
            this.GetData()
        }
        //切换每页条数
        ChangePageNum(perPage:any){
            this.initData.searchData.MaxResultCount = perPage;
            this.GetData()
        }
        //获取字典数据
        async GetDic() {
            //所有字典
            await this.$store.dispatch('project/GetAllDictionary');
            this.$store.state.project.allDictionary.map((item:any) => {
                this.initData.dicData[item.key] = item.items.map((items:any) => {
                    return {
                        label: items.displayName,
                        value: items.id
                    }
                });
            })
            //获取当前用户权限
            await this.$store.dispatch('session/init');
            this.initData.showContractOutside = this.$store.state.user.userInfo.auth.grantedPermissions['Pages.CAndMManager.C.EView'];
            this.initData.showContractLabel = this.$store.state.user.userInfo.auth.grantedPermissions['Pages.CAndMManager.C.LabelMaintain'];
            //部门字典
            await this.$store.dispatch('project/GetContractBelongOrg');
            this.initData.dicData.bearerOrg = this.$store.state.project.contractBelongOrg;
            //项目类别字典
            await this.$store.dispatch('project/GetAllProjectCatalog');
            this.initData.dicData.projectCatalog = this.$store.state.project.projectCatalog;
        }
        //导出
        Export() {
            console.log(this.initData.searchData);
            (this as any).$root.Export(this.initData.searchData, '/api/ContractFile/ExportAllMainContractAsync', '主合同台账', 'xlsx');
        }

        //初始化
        async mounted() {
            await this.GetDic();
            this.GetData();
            this.setDropdownCheckAllList();
            console.log(45154)
        }
        activated(){
            this.initData.tabsBool = false;
            this.$nextTick(function () {
                this.initData.tabsBool = true;
            });
        }
    }
